// Inline SVG icons (single-stroke line art, reference convention — no icon lib).
import React from 'react';

export function HeartIcon({ size = 24 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
			<path d='M12 20c-2.5-2.4-7.5-6-7.5-10.2C4.5 7.3 6.4 5.6 8.6 5.6c1.4 0 2.7.7 3.4 1.9.7-1.2 2-1.9 3.4-1.9 2.2 0 4.1 1.7 4.1 4.2C19.5 14 14.5 17.6 12 20z' />
		</svg>
	);
}

export function DownloadIcon({ size = 18 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
			<path d='M12 4v11M7 11l5 5 5-5M5 20h14' />
		</svg>
	);
}

export function CloseIcon({ size = 18 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' aria-hidden='true'>
			<path d='M6 6l12 12M18 6L6 18' />
		</svg>
	);
}

export function ChevronIcon({ size = 16, dir = 'right' }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
			aria-hidden='true'
			style={dir === 'left' ? { transform: 'scaleX(-1)' } : undefined}>
			<path d='M9 6l6 6-6 6' />
		</svg>
	);
}

export function PlayIcon({ size = 26 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='currentColor' aria-hidden='true'>
			<path d='M8 5.5v13l11-6.5z' />
		</svg>
	);
}

export function ExpandIcon({ size = 18 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
			<path d='M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5' />
		</svg>
	);
}

export function CheckIcon({ size = 16 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
			<path d='M4.5 12.5l5 5 10-11' />
		</svg>
	);
}

export function CameraIcon({ size = 24 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
			<rect x='3' y='6' width='18' height='14' rx='0' />
			<circle cx='12' cy='13' r='3.4' />
			<path d='M8 6l1.6-2.4h4.8L16 6' />
		</svg>
	);
}

export function FilmIcon({ size = 22 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
			<rect x='3' y='6' width='13' height='12' rx='0' />
			<path d='M16 10l5-3v10l-5-3z' />
		</svg>
	);
}

export function TrashIcon({ size = 18 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
			<path d='M4 7h16M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13M10 11v5.5M14 11v5.5' />
		</svg>
	);
}

export function PlusIcon({ size = 18 }) {
	return (
		<svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' aria-hidden='true'>
			<path d='M12 5v14M5 12h14' />
		</svg>
	);
}
